import { render, staticRenderFns } from "./DanhSachCanBoTrucThuoc.vue?vue&type=template&id=16faae13&"
import script from "./DanhSachCanBoTrucThuoc.vue?vue&type=script&lang=js&"
export * from "./DanhSachCanBoTrucThuoc.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachCanBoTrucThuoc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports